import React, { Component } from "react";
import { BrowserRouter, Router } from "react-router-dom";

// App Routes
import Routes from "./Routes";

// Vendor dependencies
import "./Vendor";
// Application Styles
import "./styles/bootstrap.scss";
import "./styles/app.scss";
import { history } from "./history";
import Axios from "axios";
import { jwtDecode } from "jwt-decode";
class App extends Component {
  render() {
    Axios.interceptors.request.use(
      async (config) => {
        let app_token = null;
        let items = null;

        try {
          const tokenString = localStorage.getItem("app-token");
          app_token = tokenString ? JSON.parse(tokenString) : null;
        } catch (error) {
          console.error("Erro ao fazer parse do token:", error);
          app_token = null;
        }

        if (app_token != null && app_token.token) {
          try {
            const decoded = jwtDecode(app_token.token);
            if (decoded.exp < Date.now() / 1000) {
              console.warn("Token expirado, redirecionando para login...");
              localStorage.clear();
              sessionStorage.clear();
              history.push("/login");
              return Promise.reject(new Error("Token expirado"));
            }
          } catch (error) {
            console.error("Erro ao decodificar token:", error);
            localStorage.clear();
            history.push("/login");
            return Promise.reject(error);
          }
        }

        try {
          const clinicString = localStorage.getItem("ClinicData");
          items = clinicString ? JSON.parse(clinicString) : null;
        } catch (error) {
          console.error("Erro ao fazer parse dos dados da clínica:", error);
          items = null;
        }

        let id = items != null ? parseInt(items.id) : 0;

        if (config.url.endsWith("api/clinic")) {
          //passa o id do usuário para alterações em dados da clínica
          try {
            const userString = localStorage.getItem("app-token");
            items = userString ? JSON.parse(userString) : null;
            id = items ? parseInt(items.id) : 0;
          } catch (error) {
            console.error("Erro ao fazer parse do token do usuário:", error);
            id = 0;
          }
        }

        let tenantid =
          config.params != undefined ? (config.params["tenantid"] ?? "") : "";

        config.headers = {
          Authorization:
            app_token != null && app_token.token
              ? `Bearer ${app_token.token}`
              : "",
          tenantid: tenantid != "" ? tenantid : id,
        };

        return config;
      },
      (error) => {
        console.error("Erro no interceptor:", error);

        // I cand handle a request with errors here
        return Promise.reject(error);
      },
    );
    // specify base href from env varible 'PUBLIC_URL'
    // use only if application isn't served from the root
    // for development it is forced to root only
    /* global PUBLIC_URL */
    const basename =
      process.env.NODE_ENV === "development" ? "/" : PUBLIC_URL || "/";

    return (
      <Router basename={basename} history={history}>
        <Routes />
      </Router>
    );
  }
}
export default App;
